import { CodeSyntax } from "@carbon/pictograms-react";
import { NetworkServices } from "@carbon/pictograms-react";
import { CarbonForIbmDotcom } from "@carbon/pictograms-react";
import { Kubernetes } from "@carbon/pictograms-react";
import { Tools } from "@carbon/pictograms-react";
import { FileBackup } from "@carbon/pictograms-react";
import { Reliability } from "@carbon/pictograms-react";
import { ArtTools_01 } from "@carbon/pictograms-react";
import * as React from 'react';
export default {
  CodeSyntax,
  NetworkServices,
  CarbonForIbmDotcom,
  Kubernetes,
  Tools,
  FileBackup,
  Reliability,
  ArtTools_01,
  React
};